import { useScreenState } from '@gogame/screens';

export const useEnsureTemporaryStateProp = (prop) => {
  const screenState = useScreenState();
  const { temporary } = screenState;
  return temporary ? temporary[prop] : screenState[prop];
};
